module.exports = "<div class=\"loader-div\">\r\n    <div class=\"spinner-border loader-hight\"></div>\r\n</div>"